<rx-intuitive-teeth-diagram-container *ngIf="(hasSelectedBridge$ | async) === false">
</rx-intuitive-teeth-diagram-container>
<rx-intuitive-teeth-diagram-bridge-container *ngIf="hasSelectedBridge$ | async">
</rx-intuitive-teeth-diagram-bridge-container>
